import React from "react";

import "./PriceDetail.scss";

function getNumberFormat(price) {
  return new Intl.NumberFormat("en-US").format(price);
}

function getTotalQty(items) {
  let totalQty = 0;
  items.map((i) => (totalQty += i.saleQty));
  return totalQty;
}

function getTotalPrice(items) {
  let totalPrice = 0;
  items.map((i) => (totalPrice += i.saleQty * i.salePrice));
  return totalPrice;
}

function getTotalDisc(items) {
  let totalDisc = 0;
  items.map((i) => (totalDisc += i.discountTotal));
  return totalDisc;
}

function getTotalAmt(items) {
  let totalAmt = 0;
  items.map((i) => (totalAmt += i.totAmt));
  return totalAmt;
}

const PriceDetail = ({ data }) => (
  <div className="price-detail">
    <div className="txt-area">
      <p>상품을 모두</p>
      <p>스캔하셨나요?</p>
    </div>
    <div className="qty-area">
      <p>총 수량</p>
      <p>
        <span>{getTotalQty(data)}</span>건
      </p>
    </div>
    <hr />
    <div className="detail-area">
      <div>
        <p>구매 금액</p>
        <p>
          <span>{getNumberFormat(getTotalPrice(data))}</span>원
        </p>
      </div>
      <div>
        <p>할인 금액</p>
        <p>
          <span>{getNumberFormat(getTotalDisc(data))}</span>원
        </p>
      </div>
    </div>
    <div className="offer-detail">할인 내용 확인</div>
    <hr />
    <div className="total-area">
      <p>합계 금액</p>
      <p>
        <span>{getNumberFormat(getTotalAmt(data))}</span>원
      </p>
    </div>
  </div>
);

export default PriceDetail;
